// eslint-disable-next-line @tseslint/typedef
export const INTERSECTION_OBSERVER_STRATEGIES = {
  /** Trigger for every element marked with the {@link ObserveDirective | appObserve} directive. */
  all: 'all',
  /** Trigger only for the last element marked with the {@link ObserveDirective | appObserve} directive. */
  last: 'last',
  /** Trigger only for the first element marked with the {@link ObserveDirective | appObserve} directive. */
  first: 'first'
} as const;
export type IntersectionObserverStrategy = keyof typeof INTERSECTION_OBSERVER_STRATEGIES;
export type IntersectionObserverOptions = Omit<IntersectionObserverInit, 'root'>;
// eslint-disable-next-line @tseslint/typedef
export const INTERSECTION_OBSERVER_EMIT_STRATEGIES = {
  /** Emits all emits of the observer, both intersection enter and leave */
  all: "all",
  /** Emits when the observed element intersects the viewport of the root  */
  enter: "enter",
  /** Emits when the observed element leaves the viewport of the root */
  leave: "leave"
} as const;
export type IntersectionObserverEmitStrategy = keyof typeof INTERSECTION_OBSERVER_EMIT_STRATEGIES;
